import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// src/components/ProtectedRoute.js
import { useContext } from 'react';
import { Navigate, Outlet, useLocation, useNavigation } from 'react-router-dom';
import { useIsMutating } from '@tanstack/react-query';
import { AbilityContext } from '@libs/@core/contexts/caslContext';
import { parseRoute } from '@libs/utils/routerParser';
import BaseLoading from '@libs/@core/components/loading/BaseLoading';
var ProtectedLayout = function () {
    var pathname = useLocation().pathname;
    var navigation = useNavigation();
    var isMutating = useIsMutating();
    var ability = useContext(AbilityContext);
    var _a = parseRoute(pathname), subject = _a.subject, action = _a.action;
    var canAccess = ability.can(action, subject);
    if (!canAccess) {
        return _jsx(Navigate, { to: '/404', replace: true });
    }
    return (_jsxs(_Fragment, { children: [(navigation.state === 'loading' || isMutating > 0) && _jsx(BaseLoading, {}), _jsx(Outlet, {})] }));
};
export default ProtectedLayout;
